export const DOM_ID = {
  appRouteOutletWrapper: 'app-route-outlet-wrapper',
}
